export class BienInmueble {
    model = {
        id: { value: null, export: false },
        idp: { value: null, export: false },
        proyecto: {
            value: '',
            header: 'Proyecto:',
            required: 'Proyecto es requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            table: true,
            sort: true
        },
        modelo: {
            value: '',
            header: 'Modelo:',
            required: 'Modelo es requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            table: true,
            sort: true
        },
        codigo_catastral: {
            value: '',
            table: true,
            header: 'Código Catastral:',
            required: 'Código catastral es requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 2 caracteres',
            max: 300,
            min: 2
        },
        manzana: {
            value: '',
            header: 'Manzana:',
            required: 'Manzana es requerida',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 2 caracteres',
            max: 300,
            min: 2
        },
        numero_solar: {
            value: '',
            header: 'Solar #:',
            required: 'Número de solar es requerido',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 2 caracteres',
            max: 100,
            min: 2
        },
        area_terreno: {
            value: 0,
            table: true,
            header: 'Área de terreno:',
            required: 'Área de terreno es requerida',
        },
        area_construccion: {
            value: 0,
            header: 'Área de construcción:',
            required: 'Área de construcción es requerida',
        },
        precio_bien: {
            value: 0,
            header: 'Precio del bien:',
            required: 'Precio del bien es requerido',
            isCurrency: true
        },
        valor_cuota_entrada: {
            value: 0,
            header: 'Valor cuota de entrada:',
            required: 'Valor de la cuota de entrada es requerido',
        },
        fecha_entrega: {
            value: null,
            header: 'Fecha de entrega:',
            required: 'Fecha de entrega es requerida',
            sort: true,
            isDate: true
        },
        pago_vista: {
            value: 0,
            header: 'Pago a la vista:',
            required: 'Pago a la vista es requerido',
        },
        saldo_deuda_inicial: {
            value: 0,
            header: 'Saldo de la deuda inicial:',
            required: 'Saldo de la deuda inicial es requerido',
        },
        numero_cuotas: {
            value: 0,
            header: 'Número de cuotas:',
            required: 'Número de cuotas es requerido',
        },
        fecha_primer_pago: {
            value: null,
            header: 'Fecha del primer pago:',
            required: 'Fecha del primer pago es requerida',
        },
        valor_financia_largo_plazo: {
            value: 0,
            header: 'Valor que financia a largo plazo:',
            required: 'Valor que financia a largo plazo es requerido',
        },
        banco_financia_largo_plazo: {
            value: '',
            header: 'Banco que financia a largo plazo:',
            required: 'Banco que financia a largo plazo es requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4
        },
        plazo_financia_credito: {
            value: 0,
            header: 'Plazo que financia el crédito (años):',
            required: 'Plazo que financia el crédito es requerido',
        },
        gastos_legales: {
            value: 0,
            header: 'Gastos legales propios o financiados:',
            required: 'Gastos legales es requerido',
        },
        responsable_precalificacion: {
            value: '',
            header: 'Responsable de precalificación:',
            required: 'Responsable de precalificación es requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4
        },
    }
}
